import { render, staticRenderFns } from "./MsgModalError.vue?vue&type=template&id=1b5d3152&scoped=true"
import script from "./MsgModalError.vue?vue&type=script&lang=js"
export * from "./MsgModalError.vue?vue&type=script&lang=js"
import style0 from "./MsgModalError.vue?vue&type=style&index=0&id=1b5d3152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d3152",
  null
  
)

export default component.exports